import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

/** Opens an address of the app: a Streaming section, a track, a store, or the Catalog. */
export function useStreamingNavigate(): (path: string) => void {
  const navigate = useNavigate();
  return useCallback(
    (path: string) => {
      // eslint-disable-next-line no-void
      void navigate(path);
    },
    [navigate]
  );
}
